<template>
    <div>
        <Register :pageTitle="pageTitle"
                  :source="source"
                  :prefillEmail="email"
                  :prefillMarketingOptIn="marketingOptIn"
                  :passUserRewardsAnswer="passUserRewardsAnswer"
                  :errorMsg="errorMsg" />
    </div>
</template>

<script setup>
    import { ref, computed, onMounted, inject } from 'vue'
    import { useRoute } from 'vue-router'
    import Register from '@/components/Register.vue'

    // Props
    const props = defineProps({
        errorMsg: String,
        setPageTitle: String,
        doesUserHaveRewards: [Boolean, String],
        email: String,
        marketingOptIn: Boolean
    })

    // Route
    const route = useRoute()

    // isMyBeauty (use inject if provided globally, or compute from route)
    const isMyBeauty = inject('isMyBeauty', computed(() =>
        route.params.isMyBeauty === 'mybeauty' ||
        route.query.isMyBeauty === 'true' ||
        route.query.isMyBeauty === true
    ))

    const source = computed(() => route.query.l)
    const pageTitle = ref('Join Harrods Rewards')
    const passUserRewardsAnswer = computed(() => props.doesUserHaveRewards)

    onMounted(() => {
        if (isMyBeauty.value) {
            pageTitle.value = 'Tell Us About You'
        }
    })
</script>
